export default "__VITE_ASSET__C6pW6rim__";